import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";

interface CustomerInfoBarProps {
  data?: {
    customer?: {
      name?: string;
    };
    stage?: string;
    leadId?: string | number;
  };
}

const CustomerInfoBar: FC<CustomerInfoBarProps> = ({ data }) => {
  const { customerStorageResponse } = useSelector(
    (state: any) => state.contractStorage
  );

  const customerName =
    data?.customer?.name ||
    customerStorageResponse?.removalCustomer?.name ||
    "—";

  const stage =
    data?.stage ||
    customerStorageResponse?.leadStatus ||
    "—";

  const serialNo =
    data?.leadId ||
    customerStorageResponse?.leadId ||
    "—";

  const items = [
    ["Customer name", customerName],
    ["Stage", stage],
    ["Serial No", serialNo],
  ];

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 2,
        py: 1,
        bgcolor: "#E5F4F1",
        borderRadius: 1,
        fontSize: 13,
        color: "#555",
      }}
    >
      {items.map(([label, value], index) => (
        <Box key={label} sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          {index > 0 && (
            <Typography component="span" sx={{ color: "#BBB", mr: 0.5 }}>
              •
            </Typography>
          )}

          <Typography component="span" sx={{ fontSize: 13 }}>
            {label}: <b>{value}</b>
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default CustomerInfoBar;